import { render, staticRenderFns } from "./MarketplaceSoldListing.vue?vue&type=template&id=5ca70dbc"
import script from "./MarketplaceSoldListing.vue?vue&type=script&lang=js"
export * from "./MarketplaceSoldListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports